import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CamelCaseToHrfPipe,
  FormateIfDatePipe,
  NullFormatterPipe,
  NumberToSymbolPipe,
} from 'common';
import { CheckboxComponent } from 'ui-elements/form/checkbox';
import { RadioComponent } from 'ui-elements/form/radio';
import {
  SsNgCellKeyDirective,
  SsNgHeaderKeyDirective,
  SsTableComponent,
  SsTableFooterDirective,
  SsTableHeaderDirective,
  SsTableTemplatePipe,
} from './table.component';

const TABLE_DIRECTIVES = [
  SsTableHeaderDirective,
  SsTableFooterDirective,
  SsNgCellKeyDirective,
  SsNgHeaderKeyDirective,
  SsTableTemplatePipe,
  SsTableComponent,
];

@NgModule({
  declarations: TABLE_DIRECTIVES,
  imports: [
    CommonModule,
    CdkTableModule,
    CamelCaseToHrfPipe,
    NumberToSymbolPipe,
    NullFormatterPipe,
    FormateIfDatePipe,
    CheckboxComponent,
    RadioComponent,
    DragDropModule,
  ],
  exports: [TABLE_DIRECTIVES],
})
export class SsNgTableModule {}
